export default "__VITE_ASSET__DHZhZJQC__"